import css from 'styled-jsx/css';

const styles = css.global`#page-renegociacao-financiamentos {
    display: none;
    background: #FBFBFB;
}

#page-renegociacao-financiamentos.show {
    display: block;
}

#perguntas {
    padding-top: 48px;
}
#perguntas .perguntas-contain {
    margin-top: 0;
}

@media (min-width: 992px) {
    #perguntas {
        padding-top: 112px;
    }
}
@media (min-width: 1280px) {
    .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
    }
  }`;

export default styles;